<template>
  <div class="info-container normal-font">

    <div class="row justify-end">
      <q-btn
          round
          dense
          flat
          icon="close"
          color="primary"
          @click="router.back()"
      />
    </div>

    <h5>1. Buchung & Bezahlung</h5>
    <p>
      Eine Buchung wird mit einer Anzahlung in Höhe von <strong>50 €</strong> verbindlich. Die Anzahlung wird auf den Gesamtpreis der
      Dienstleistung angerechnet. Der Restbetrag ist unmittelbar vor Ort zu entrichten, sofern nichts anderes vereinbart wurde. Es
      stehen die Zahlungsmethoden über <strong>Stripe</strong> zur Verfügung, die es dem Kunden ermöglichen, bequem per Kreditkarte oder
      anderen unterstützten Zahlungsmethoden zu bezahlen.
    </p>

    <p>
      Im Falle einer vorzeitigen Kündigung durch den Kunden ist die Anzahlung nur dann erstattungsfähig, wenn dies ausdrücklich vereinbart
      wurde. Andernfalls bleibt die Anzahlung als Entschädigung für die nicht wahrgenommene Leistung bestehen.
    </p>

    <h5>2. Anzahlungen & Stornierungen</h5>
    <p>Die Anzahlung dient der Sicherung des Termins.</p>
    <p>
      <strong>Absage durch den Kunden:</strong> Bei Absagen bis spätestens <strong>2 Tage vor dem Termin</strong> bleibt die Anzahlung gültig
      und wird auf einen neuen Termin angerechnet. Die Stornierung muss schriftlich erfolgen, per E-Mail an info@pay-r.de.
    </p>
    <p>
      Bei späteren Absagen oder Nichterscheinen verfällt die Anzahlung, es sei denn, der Kunde weist nach, dass ein geringerer Schaden
      entstanden ist. In diesem Fall muss der Kunde geeignete Nachweise erbringen (z. B. ärztliches Attest oder andere Dokumente).
    </p>

    <h5>3. Terminänderungen durch die Anbieterin</h5>
    <p>
      Muss ein Termin aus wichtigen Gründen verschoben werden, bleibt die Anzahlung gültig und wird auf einen neuen Termin übertragen. Der
      Kunde wird in diesem Fall rechtzeitig informiert. Der Kunde hat das Recht, vom Vertrag zurückzutreten und die Anzahlung
      zurückzuerhalten, wenn er mit der neuen Terminvereinbarung nicht einverstanden ist.
    </p>

    <h5>4. Pünktlichkeit & Ablauf</h5>
    <p>
      Der Kunde verpflichtet sich, pünktlich zu erscheinen. Bei Verspätung verkürzt sich die vereinbarte Zeit entsprechend; die verlorene Zeit
      wird nicht nachgeholt.
    </p>
    <p>
      Respektvolles und angemessenes Verhalten ist Voraussetzung für die Durchführung der Dienstleistung. Bei
      <strong>schwerwiegenden Verstößen</strong> (z. B. Beleidigungen, Belästigungen, diskriminierende Äußerungen) kann die Anbieterin die
      Dienstleistung abbrechen. In diesem Fall besteht kein Anspruch auf Rückerstattung. Ein schwerwiegender Verstoß liegt vor, wenn der Kunde
      durch sein Verhalten die Durchführung der Dienstleistung gefährdet oder die Anbieterin in unzumutbarer Weise belästigt.
    </p>

    <h5>5. Haftung</h5>
    <p>
      Die Anbieterin haftet unbeschränkt für Schäden aus Verletzungen von <strong>Leben, Körper und Gesundheit</strong>, die auf einer
      vorsätzlichen oder fahrlässigen Pflichtverletzung beruhen.
    </p>
    <p>
      Für sonstige Schäden haftet die Anbieterin nur bei <strong>Vorsatz</strong> und <strong>grober Fahrlässigkeit</strong>. Eine
      weitergehende Haftung ist ausgeschlossen.
    </p>
    <p>
      Vor der ersten Sitzung ist der Kunde verpflichtet, einen gesonderten Hinweis- und Aufklärungsbogen zu unterschreiben. Ohne diese
      Unterschrift kann die Sitzung nicht stattfinden. Dies gilt für alle Sitzungen, die in einem Kontext durchgeführt werden, der besondere
      Risiken birgt (z. B. körpernahe Dienstleistungen).
    </p>

    <h5>6. Rückbuchungen & rechtliche Hinweise</h5>
    <p>
      Unberechtigte Rückbuchungen (Chargebacks) können zur Sperrung des Kundenkontakts führen und werden gegebenenfalls rechtlich verfolgt.
    </p>
    <p>
      Es gilt das gesetzliche <strong>Widerrufsrecht für Verbraucher</strong> bei Fernabsatzgeschäften. Der Kunde kann den Vertrag innerhalb
      von 14 Tagen ohne Angabe von Gründen widerrufen. Das Widerrufsrecht erlischt jedoch, wenn die Dienstleistung bereits vollständig
      erbracht wurde. Nähere Informationen enthält die separate <strong>Widerrufsbelehrung</strong>.
    </p>

    <h5>7. Datenschutz</h5>
    <p>
      Alle Kundendaten werden ausschließlich zur Vertragsdurchführung genutzt und vertraulich behandelt. Eine Weitergabe an Dritte erfolgt
      nur, soweit dies zur Vertragserfüllung erforderlich ist oder eine gesetzliche Pflicht besteht. Weitere Einzelheiten zur Verarbeitung von
      personenbezogenen Daten und den Rechten der betroffenen Personen entnehmen Sie bitte unserer <strong>Datenschutzerklärung</strong>.
    </p>

    <h5>8. Schlussbestimmungen</h5>
    <p>
      Mit der Buchung eines Termins akzeptiert der Kunde diese AGB. Änderungen bleiben vorbehalten, sofern sie dem Kunden
      <strong>vor Vertragsabschluss</strong> mitgeteilt werden. Es gilt deutsches Recht. Der Gerichtsstand ist
      <strong>Frankfurt am Main</strong>, wenn der Kunde Kaufmann ist oder seinen gewöhnlichen Aufenthalt außerhalb von Deutschland hat.
    </p>

    <div class="row justify-center">
      <q-btn
          no-caps
          flat
          size="lg"
          color="primary"
          label="Zrück"
          icon="arrow_back_ios"
          @click="router.back()"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { useRouter } from 'vue-router'

const router = useRouter()

</script>
